import React from 'react';

import PricingOptionHeader from './PricingOptionHeader';
import PricingOptionBody from './PricingOptionBody';

import 'bootstrap/dist/css/bootstrap.css';
import './pricingoption.styl'

class PricingOption extends React.Component {
  render() {
    return (
      <div className={ 'pricing-option ' + this.props.option.type }>
        <PricingOptionHeader
          icon={ this.props.option.header.icon }
          title={ this.props.option.header.title }
          meta={ this.props.option.header.meta }
        />
        <PricingOptionBody
          price={ this.props.option.body.price }
          features={ this.props.option.body.features }
          cta={ this.props.option.body.cta }
        />
      </div>
    );
  }
}

// PricingOptions.contextTypes = {
//   router: PropTypes.object.isRequired
// }
export default PricingOption;



// WEBPACK FOOTER //
// ./src/components/pricingoptions/pricingoption/PricingOption.js